module.exports = __webpack_public_path__ + "img/aboutusinfo.73926b70.jpg";